import styled from "@emotion/styled";
import { Form, Input, Select } from "antd";
import { FC, useCallback, useEffect, useState } from "react";
import CouponSelector from "./couponSelector";
import SubscriptionSelector from "./subScriptionSelector";

interface IProps {
	value?: any;
	onChange?: (data: any) => void;
}

const PopupOffer: FC<IProps> = (props: IProps) => {
	const [popupType, setPopupType] = useState<number | void>(void 0);
	const popupTypeOptions = [
		{
			label: "优惠券",
			value: 1,
		},
		{
			label: "会员卡",
			value: 2,
		},
		{
			label: "问候语",
			value: 3,
		},
	];
	const init = useCallback(() => {
		setPopupType(props.value);
	}, [props.value]);

	useEffect(() => {
		init();
	}, [init]);

	return (
		<Container>
			<Form.Item label='弹窗类型' name='popupType'>
				<Select options={popupTypeOptions} placeholder='请选择弹窗类型' value={popupType} onChange={setPopupType} />
			</Form.Item>
			<div className='offerContainer'>
				<div className='offerIptContainer'>
					{popupType === 1 && (
						<Form.Item label='优惠券' name='couponsList'>
							<CouponSelector />
						</Form.Item>
					)}
					{popupType === 2 && (
						<Form.Item label='会员卡' name='subscriptionId'>
							<SubscriptionSelector />
						</Form.Item>
					)}
					<Form.Item label={popupType === 3 ? "问候语" : "备注1"} name='remark1'>
						<Input.TextArea placeholder={"请输入" + (!popupType ? "问候语" : "备注")} />
					</Form.Item>
					<Form.Item label='备注2' name='remark2'>
						<Input.TextArea placeholder='请输入备注' />
					</Form.Item>
				</div>
			</div>
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
	background: #fafafa;
	box-sizing: border-box;
	padding: 30px;
	.offerContainer {
		width: 100%;
		min-height: 200px;
		box-sizing: border-box;
		padding: 10px;
		.offerTitle {
			margin-bottom: 5px;
		}

		.offerIptContainer {
			width: 100%;
			min-height: 100px;
			border: 1px solid #e9e9e9;
			box-sizing: border-box;
			padding: 10px;
			padding-top: 30px;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
	}
`;

export default PopupOffer;
